import React from 'react';

function Spinner() {
  return (
    <div className="loading">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
export default Spinner;
